import React from 'react';
import ChatInterface from '../ChatInterface';
import './TestChatbot.css';

const TestChatbot = () => {
  return (
    <div className="test-chatbot-page">
      <div className="test-header">
        <h2>Test Your Chatbot</h2>
        <p className="test-description">
          Test your chatbot here before deploying it to your website. 
          Select a document from the dropdown above the chat to get started.
        </p>
      </div>

      <div className="chatbot-test-container">
        <ChatInterface />
      </div>

      <div className="test-info">
        <h3>Testing Tips</h3>
        <ul>
          <li>Ask questions about the content in your uploaded documents</li>
          <li>Test different types of questions to see how the chatbot responds</li>
          <li>Check if the responses are accurate and well-formatted</li>
          <li>Use the Analytics page to see query statistics after testing</li>
        </ul>
      </div>
    </div>
  );
};

export default TestChatbot;
